import { DragDropContext, Draggable, Droppable } from "@hello-pangea/dnd"
import {
 Button,
 CounterGraph,
 Header,
 Input,
 MyMap,
 OccupancyGraph,
 SideBarCategory,
 SideBarInnerCategory,
 SideBarSubCategory,
} from "components"
import React, { FormEvent, useEffect, useState } from "react"
import { useSelector } from "react-redux"
import { Link } from "react-router-dom"
import { Box } from "theme-ui"
import { v4 as uuidv4 } from "uuid"
import { useFetchDeviceDetectorsQuery } from "../store/Features/devices/deviceDetectors-api-slice"
import { useFetchCountingValuesMutation } from "../store/Features/processData/countingValues-api-slice"

import { IDeviceGroup, IDeviceTree, IDeviceTreeGroupElement } from "@types"
import Skeleton from "react-loading-skeleton"
import "react-loading-skeleton/dist/skeleton.css"
import { useDispatch } from "react-redux"
import { compareDeviceGroupElements, compareNumber } from "utils/assert"
import { distinctArrayOfDeviceTreeGroupElements } from "utils/distinct"
import arrow_icon from "../selecticon.png"
import { useFetchDeviceQuery } from "../store/Features/devices/devices-api-slice"
import { setDashboardDeviceIds } from "../store/Slices/dashboardDeviceIds"

interface IDate {
 begin: string
 end: string
}
interface CheckboxValues {
 occupancy: boolean
 counter: boolean
}

interface ISelectedOption {
 id?: string
 type?: string
 name?: string
 size?: string
 selectedDeviceId?: number[]
}
interface IItem {
 id: string
 // name:string
 type: string
 name: string
 size: string
 selectedDeviceId: number[]
}
interface IDashboardState {
 isDraggable: boolean

 isEditable: boolean

 items: IItem[]
}

export const DashBoard = () => {
 const dispatch = useDispatch()
 const { data: devicetreedata, isLoading } = useFetchDeviceQuery()
 const dashboardData: any = useSelector((state: any) => state.dashboardDevicesIds.dashboardSetting)

 // state for open All
 const [openAllDevices, setOpenAllDevices] = useState<boolean>(false)

 // State for Open Server list
 const [openServerList, setOpenServerList] = useState<number[]>([])

 // State for Open Device group List
 const [openDeviceGroup, setOpenDeviceGroup] = useState<number[]>([])

 // state for Selected Devices
 const [selectedDeviceTreeGroupElements, setSelectedDeviceTreeGroupElements] = useState<
  IDeviceTreeGroupElement[]
 >([])
 const [FetchCounterValues] = useFetchCountingValuesMutation()
 const { data } = useFetchDeviceDetectorsQuery()
 const [allData, setAllData] = useState([])
 const [date, setDate] = useState<IDate>({ begin: "", end: "" })
 const [selectedDetectors, setSelectedDetectors] = useState<string[]>([])
 const [selectAll, setSelectAll] = useState(false)
 const [selectedOption, setSelectedOption] = useState<ISelectedOption | null>()
 const [toggle, setToggle] = useState(false)
 const [settings, setSettings] = useState(false)

 const [checkboxValues] = useState<CheckboxValues>({
  occupancy: false,
  counter: false,
 })
 const [detectorCounts, setDetectorCounts] = useState({
  totalDetectors: 0,
  malfunctioningDetectors: 0,
  okDetectors: 0,
 })

 // Inside your component function
 const [isLoadingData, setIsLoadingData] = useState(true)

 //  graphdata
 useEffect(() => {
  if (date.begin && date.end) {
   FetchCounterValues(date)
    .then((res: any) => {
     setAllData(res?.data)
    })
    .catch((e: any) => {
     console.log("e", e)
    })
  }
 }, [date.begin, date.end])

 const Ids = dashboardData.items.map((item: any) => item.selectedDeviceId)
 const flattenedIds = Ids.flat()

 const _selectedDeviceData =
  allData && allData.filter((item: any) => flattenedIds.includes(item.common_information.device_id))

 // Create a Set to store unique detector names
 const uniqueDetectorNamesSet = new Set()

 // Iterate over the data array and populate the Set
 data &&
  _selectedDeviceData &&
  _selectedDeviceData?.forEach((item: any) => {
   item.oepnv_data_elements?.forEach((element: any) => {
    element.detector_list?.forEach((detector: any) => {
     uniqueDetectorNamesSet?.add(detector.detector_name)
    })
   })
  })
 const _SingleDetectorName = Array?.from(uniqueDetectorNamesSet)

 const handleDetectorCheckboxChange = (detectorName: string) => {
  setSelectedDetectors((prevDetectors) => {
   const updatedDetectors = prevDetectors.includes(detectorName)
    ? prevDetectors.filter((name) => name !== detectorName)
    : [...prevDetectors, detectorName]

   // Check if all detectors are selected after the change
   const allDetectorsSelected = updatedDetectors.length === _SingleDetectorName.length

   // Update the state of "Select All" checkbox
   setSelectAll(allDetectorsSelected)

   return updatedDetectors
  })
 }

 const handleSelectAllChange = () => {
  // Toggle the state of "all" checkbox
  setSelectAll(!selectAll)

  // If "all" is selected, update the state with all detector names
  const updatedDetectors: any = !selectAll ? _SingleDetectorName : []

  setSelectedDetectors(updatedDetectors)
 }

 //  end
 // Simulating loading delay with setTimeout
 useEffect(() => {
  const timer = setTimeout(() => {
   setIsLoadingData(false)
  }, 2000) // Adjust the delay time as needed

  return () => clearTimeout(timer)
 }, [])

 useEffect(() => {
  if (data) {
   // Calculate total detectors, malfunctioning detectors, and ok detectors
   let total = 0
   let malfunctioning = 0
   let ok = 0

   data?.forEach((device) => {
    device.detectors.forEach((detector) => {
     total++
     if (detector.detector_status === "detector malfunctioning") {
      malfunctioning++
     } else {
      ok++
     }
    })
   })

   setDetectorCounts({
    totalDetectors: total,
    malfunctioningDetectors: malfunctioning,
    okDetectors: ok,
   })
  }
 }, [data])

 const handleInputChange = (value: string, name: string) => {
  setDate((prevDate: any) => ({
   ...prevDate,
   [name]: value,
  }))
 }

 const onDragEnd = (result: any) => {
  const { destination, source } = result

  if (
   !destination ||
   (destination.droppableId === source.droppableId && destination.index === source.index)
  ) {
   return
  }

  const newItems: any = Array.from(dashboardData.items)
  const [reorderedItem] = newItems.splice(source.index, 1)
  newItems.splice(destination.index, 0, reorderedItem)
  dispatch(setDashboardDeviceIds({ ...dashboardData, items: newItems }))
 }

 //  devicetree code here

 const restructuredData: IDeviceTree[] = devicetreedata
  ? devicetreedata.map((server: IDeviceTree) => ({
     ...server,
     device_groups: server.device_groups.map((deviceGroup: IDeviceGroup) => ({
      ...deviceGroup,
      server_id: server.server_id,
      devices: distinctArrayOfDeviceTreeGroupElements(deviceGroup.devices).map(
       (device: IDeviceTreeGroupElement) => ({
        ...device,
        group_id: deviceGroup.group_id,
        server_id: server.server_id,
       }),
      ),
     })),
    }))
  : []

 const allDevices: IDeviceTreeGroupElement[] = restructuredData
  ? restructuredData
     .map((server: IDeviceTree) =>
      server.device_groups.map((deviceGroup: IDeviceGroup) =>
       deviceGroup.devices.map((device: IDeviceTreeGroupElement) => device),
      ),
     )
     .flat()
     .flat()
  : []

 const reqHandlerForSelectedDevices = () => {
  const deviceIds = selectedDeviceTreeGroupElements.map(
   (device: IDeviceTreeGroupElement) => device.device_id,
  )
  setSelectedOption((prev: any) => ({
   ...prev,
   selectedDeviceId: deviceIds,
  }))
  //   dispatch(setDashboardDeviceIds({ deviceIds: deviceIds }))
 }

 useEffect(() => {
  if (!isLoading) reqHandlerForSelectedDevices()
  // eslint-disable-next-line
 }, [selectedDeviceTreeGroupElements])

 const handleCheckOpenAllDevices = (allOpenServers: number[], allOpenGroups: number[]) => {
  const serverList: number[] | undefined = []
  const deviceGroups: number[] | undefined = []

  restructuredData?.forEach((server: IDeviceTree) => {
   serverList.push(server.server_id)
   server.device_groups.forEach((deviceGroup: IDeviceGroup) => {
    deviceGroups?.push(deviceGroup.group_id)
   })
  })
  if (compareNumber(serverList, allOpenServers) && compareNumber(deviceGroups, allOpenGroups)) {
   setOpenAllDevices(true)
  }
 }

 // toggle open All
 const toggleOpenAll = () => {
  if (!openAllDevices) {
   const serverList: number[] | undefined = []
   const deviceGroups: number[] | undefined = []

   restructuredData?.forEach((server: IDeviceTree) => {
    serverList.push(server.server_id)
    server.device_groups.forEach((deviceGroup: IDeviceGroup) => {
     deviceGroups?.push(deviceGroup.group_id)
    })
   })
   serverList && setOpenServerList(serverList)
   deviceGroups && setOpenDeviceGroup(deviceGroups)
  } else {
   setOpenServerList([])
   setOpenDeviceGroup([])
  }
  setOpenAllDevices(!openAllDevices)
 }

 // toggle open server
 const handleOpenServerList = (serverId: number) => {
  if (openServerList.includes(serverId)) {
   setOpenServerList(openServerList.filter((id) => id !== serverId))
  } else {
   const updatedOpenServerList = [...openServerList, serverId]
   setOpenServerList(updatedOpenServerList)
   handleCheckOpenAllDevices([...updatedOpenServerList], [...openDeviceGroup])
  }
 }

 // Toggle Open Device Group
 const toggleOpenDeviceGroup = (groupId: number) => {
  if (openDeviceGroup.includes(groupId)) {
   setOpenDeviceGroup(openDeviceGroup.filter((id: number) => id !== groupId))
  } else {
   const updatedOpenDeviceGroup = [...openDeviceGroup, groupId]
   setOpenDeviceGroup(updatedOpenDeviceGroup)
   handleCheckOpenAllDevices([...openServerList], [...updatedOpenDeviceGroup])
  }
 }

 // toggle select All
 const toggleSelectAll = () => {
  if (compareDeviceGroupElements(allDevices, selectedDeviceTreeGroupElements)) {
   setSelectedDeviceTreeGroupElements([])
  } else {
   setSelectedDeviceTreeGroupElements([...allDevices])
  }
 }
 // end here

 const handleChange = (event: any) => {
  const { value } = event.target

  setSelectedOption((prevState: any) => ({
   ...prevState,
   type: value,
   name: value,
   selectedDeviceId: prevState?.selectedDeviceId ? prevState?.selectedDeviceId : [],
   size: prevState?.size ? prevState?.size : "",
  }))
 }

 //  remove items from local storage

 const handleRemoveClick = (idToRemove: any) => {
  const duplicate = { ...dashboardData }
  let duplicateItems = [...duplicate.items]
  duplicateItems = duplicateItems.filter((item: any) => item.id !== idToRemove)
  duplicate.items = duplicateItems

  dispatch(setDashboardDeviceIds({ ...duplicate }))
 }

 const handleAddItem = (e: FormEvent<HTMLFormElement>) => {
  e.preventDefault()
  if (!selectedOption || !selectedOption.type || !selectedOption.name || !selectedOption.size) {
   return
  }

  const editData = dashboardData.items?.some((item: any) => item.id === selectedOption?.id)

  if (editData) {
   const duplicate: IDashboardState = { ...dashboardData }
   // Find the index of the item to be updated
   const index = dashboardData.items.findIndex((item: any) => item.id === selectedOption?.id)

   // Create a copy of the items array

   if (index !== -1) {
    // Update the item at the specified index
    const duplicateItems = [...duplicate.items]
    duplicateItems[index] = { ...(selectedOption as IItem) }
    duplicate.items = duplicateItems // Keep existing properties
   }

   // Dispatch action to update Redux store with the updated state
   dispatch(setDashboardDeviceIds(duplicate))
   setSelectedOption(null)

   // Set the updated selected option in state
  } else {
   // Generate a new ID
   const newId = uuidv4()
   setSelectedDeviceTreeGroupElements([])
   // Update selectedOption with the new ID
   const duplicate: IDashboardState = { ...dashboardData }
   if (selectedOption?.type)
    duplicate.items = [...duplicate.items, { ...selectedOption, id: newId } as IItem]

   // Set the updated selected option in state

   // Dispatch action to update Redux store with the updated state
   dispatch(setDashboardDeviceIds(duplicate))

   // Reset selectedOption to empty state
   setSelectedOption(null)
  }

  setToggle(false)
 }

 // Retrieve data from local storage when the component mounts

 const handleEditClick = (id: string) => {
  // Ensure dashboardData and its items are defined
  if (dashboardData && dashboardData.items) {
   // Find the item to edit based on its ID
   const itemToEdit: IItem = dashboardData.items.find((item: IItem) => item.id === id)

   // Create a new object with the updated items array

   if (itemToEdit) {
    setSelectedOption({ ...itemToEdit })
    setSelectedDeviceTreeGroupElements(
     allDevices.filter((device: IDeviceTreeGroupElement) =>
      itemToEdit.selectedDeviceId.includes(device.device_id),
     ),
    )
    // Set toggle to true to indicate edit mode
    setToggle(true)
   }
  }
 }
 const handleDraggableToggle = () => {
  dispatch(
   setDashboardDeviceIds({
    ...dashboardData,
    isDraggable: !dashboardData.isDraggable,
   }),
  )
 }

 const handleEditableToggle = () => {
  dispatch(
   setDashboardDeviceIds({
    ...dashboardData,
    isEditable: !dashboardData.isEditable,
   }),
  )
 }
 const handleResizableToggle = (event: React.ChangeEvent<HTMLInputElement>) => {
  const { value } = event.target

  const duplicateSelectedOption: ISelectedOption = { ...selectedOption }
  duplicateSelectedOption.size = value
  setSelectedOption({ ...duplicateSelectedOption })
 }

 const handleDeviceName = (event: any) => {
  const { value } = event.target

  const duplicateSelectedOption: ISelectedOption = { ...selectedOption }
  duplicateSelectedOption.name = value
  setSelectedOption({ ...duplicateSelectedOption })
 }

 return (
  <div>
   <Header />
   <div className="w-full flex justify-end pr-4 mt-4">
    <div
     className="bg-golden rounded cursor-pointer w-[15%] z-[5] flex justify-center items-center py-3"
     onClick={() => setSettings(!settings)}
    >
     <div>
      <img className={settings ? "rotate-360" : "rotate-180"} src={arrow_icon} />
     </div>
     <h1 className="ml-3">Dashboard Settings</h1>
    </div>

    {settings && (
     <div className="w-[15%] text-black p-4 rounded absolute top-[160px] right-3 bg-white z-[15]">
      <div className="flex justify-center w-full z-[5]">
       <Button
        onClick={() => {
         setToggle(!toggle)
         setSettings(false)
        }}
        size="sm"
       >
        Add New Tile
       </Button>
      </div>
      <div className="pt-2">
       <div className="custom-checkbox">
        <input
         checked={dashboardData.isDraggable}
         onChange={handleDraggableToggle}
         type="checkbox"
         id="isDraggable"
        />
        <label className="font-semi font-sm Jakarta-font" htmlFor="isDraggable">
         Draggable
        </label>
       </div>

       <div className="custom-checkbox">
        <input
         checked={dashboardData.isEditable}
         onChange={handleEditableToggle}
         type="checkbox"
         id="isEditable"
        />
        <label className="font-semi font-sm Jakarta-font" htmlFor="isEditable">
         Editable
        </label>
       </div>
      </div>
     </div>
    )}
   </div>

   {toggle && (
    <div className="relative z-30" aria-labelledby="modal-title" role="dialog" aria-modal="true">
     <div className="fixed inset-0 z-10 w-screen overflow-y-scroll">
      <div className="fixed top-0 inset-0 bg-black bg-opacity-50 flex h-screen items-end justify-center p-4 text-center sm:items-center sm:p-0">
       <form onSubmit={handleAddItem} className=" w-full flex justify-center h-full">
        <Box
         bg="highlight"
         className="relative transform  rounded-lg  text-left shadow-xl transition-all sm:w-full sm:max-w-2xl h-[75vh]  pt-3"
        >
         <div className="flex justify-center w-[90%] mx-auto pt-2">
          <div className="w-full">
           <Button
            className={
             selectedOption && selectedOption.type ? "pointer-events-auto" : "cursor-not-allowed"
            }
            size="lg"
            type="submit"
           >
            {dashboardData.items?.some((item: any) => item.id === selectedOption?.id)
             ? "Update Tile"
             : "Add Tile"}
           </Button>
          </div>
          <div className="w-full ml-2">
           <Button
            size="lg"
            onClick={() => {
             setToggle(false)
             setSelectedOption(null)
            }}
           >
            Back
           </Button>
          </div>
         </div>

         <div className="mt-2 flex justify-between w-[90%] mx-auto">
          <div>
           <div className=" flex items-center">
            <input
             className="mr-2 radio-yellow"
             type="radio"
             id="deviceId"
             name="device"
             value="Device"
             onChange={handleChange}
             checked={(selectedOption && selectedOption?.type === "Device") || false}
            />
            <label className="font-semibold font-sm Jakarta-font" htmlFor="deviceId">
             Devices
            </label>
           </div>
           <div className=" flex items-center">
            <input
             className="mr-2 radio-yellow"
             type="radio"
             id="detectorId"
             name="device"
             value="Detector"
             onChange={handleChange}
             checked={(selectedOption && selectedOption?.type === "Detector") || false}
            />
            <label className="font-semibold font-sm Jakarta-font" htmlFor="detectorId">
             Detectors
            </label>
           </div>
           <div className="flex items-center">
            <input
             className="mr-2 radio-yellow"
             type="radio"
             id="mapId"
             name="device"
             value="Map"
             onChange={handleChange}
             checked={(selectedOption && selectedOption?.type === "Map") || false}
            />
            <label className="font-semibold font-sm Jakarta-font" htmlFor="mapId">
             Map
            </label>
           </div>
           <div className="flex items-center">
            <input
             className="mr-2 radio-yellow"
             type="radio"
             id="graphId"
             name="device"
             value="Graph"
             onChange={handleChange}
             checked={(selectedOption && selectedOption?.type === "Graph") || false}
            />
            <label className="font-semibold font-sm Jakarta-font" htmlFor="graphId">
             Counter Graph
            </label>
           </div>
          </div>

          <div>
           <h1 className="font-semibold font-sm Jakarta-font">Cards Size</h1>
           <div>
            <div>
             <input
              className="mr-2 radio-yellow"
              checked={(selectedOption && selectedOption.size === "isSm") || false}
              onChange={handleResizableToggle}
              type="radio"
              name="sizes"
              value="isSm"
              id="isSm"
             />
             <label className="font-semibold font-sm Jakarta-font" htmlFor="isSm">
              Small
             </label>
            </div>
            <div>
             <input
              className="mr-2 radio-yellow"
              checked={(selectedOption && selectedOption.size === "isMd") || false}
              onChange={handleResizableToggle}
              type="radio"
              name="sizes"
              value="isMd"
              id="isMd"
             />
             <label className="font-semibold font-sm Jakarta-font" htmlFor="isMd">
              Medium
             </label>
            </div>
            <div>
             <input
              className="mr-2 radio-yellow"
              checked={(selectedOption && selectedOption.size === "isLg") || false}
              onChange={handleResizableToggle}
              type="radio"
              name="sizes"
              value="isLg"
              id="isLg"
             />
             <label className="font-semibold font-sm Jakarta-font" htmlFor="isLg">
              large
             </label>
            </div>
           </div>
          </div>
         </div>
         <div className="w-[90%] mx-auto pb-2">
          <div className="flex items-center w-[80%]">
           <h1 className="font-semibold font-sm Jakarta-font">Name:</h1>
           <input
            className="outline-none bg-golden rounded py-2 px-2 ml-2"
            type="text"
            name="name"
            value={selectedOption?.name ?? ""}
            onChange={handleDeviceName}
           />
          </div>
         </div>
         {/* devicetree code  */}

         {selectedOption?.type && (
          <Box bg="highlight" color="text" className="w-full relative h-72 overflow-y-auto">
           <div className="w-full">
            {isLoading ? (
             <div className="w-[90%] mt-8 device-loader mx-auto">
              <Skeleton className="py-1 my-1 w-full" count={3} />
             </div>
            ) : (
             <div>
              <div className="flex gap-2 py-4 rounded w-11/12 mx-auto">
               <div
                onClick={() => toggleOpenAll()}
                className="bg-golden h-6 w-6 rounded border-yellow border flex justify-center items-center cursor-pointer"
               >
                <img
                 className={` ${openAllDevices ? "rotate-360" : "rotate-180"}`}
                 src={arrow_icon}
                 alt="selectIcon"
                 loading="lazy"
                />
               </div>

               <Box color="text">
                {!compareDeviceGroupElements(allDevices, selectedDeviceTreeGroupElements) &&
                selectedDeviceTreeGroupElements.length ? (
                 <div className="flex gap-2">
                  <span
                   className="bg-golden h-[24px] w-[22px] rounded border-yellow border flex justify-center items-center cursor-pointer"
                   onClick={() => {
                    toggleSelectAll()
                   }}
                  >
                   <div className="w-[8px] h-[2px] bg-black"></div>
                  </span>
                  <label className="font-semibold font-sm Jakarta-font">All Devices</label>
                 </div>
                ) : (
                 <div className="custom-checkbox">
                  <input
                   className="bg-golden"
                   //  method to select/unselect all
                   onChange={() => {
                    toggleSelectAll()
                   }}
                   type="checkbox"
                   checked={compareDeviceGroupElements(allDevices, selectedDeviceTreeGroupElements)}
                   id="allDevices"
                  />
                  <label className="font-semibold font-sm Jakarta-font" htmlFor="allDevices">
                   All Devices
                  </label>
                 </div>
                )}
               </Box>
              </div>{" "}
              {restructuredData?.map((server: IDeviceTree, index: number) => (
               <div key={index}>
                {/* ======  SideBar for servers/device-tree  ===== */}

                <SideBarCategory
                 server={server}
                 handleOpenServerList={handleOpenServerList}
                 openServerList={openServerList}
                 setSelectedDeviceTreeGroupElements={setSelectedDeviceTreeGroupElements}
                 selectedDeviceTreeGroupElements={selectedDeviceTreeGroupElements}
                />

                {openServerList.includes(server.server_id) && (
                 <ul>
                  {server.device_groups.map((group: IDeviceGroup, groupIndex: number) => (
                   <div key={groupIndex}>
                    <li>
                     {/* ======  SideBar For DeviceGroup  ===== */}
                     <SideBarSubCategory
                      group={group}
                      openDeviceGroup={openDeviceGroup}
                      toggleOpenDeviceGroup={toggleOpenDeviceGroup}
                      setSelectedDeviceTreeGroupElements={setSelectedDeviceTreeGroupElements}
                      selectedDeviceTreeGroupElements={selectedDeviceTreeGroupElements}
                     />
                    </li>
                    {openDeviceGroup.includes(group.group_id) && (
                     <li>
                      {/* =====  SideBar Devices ====== */}
                      <SideBarInnerCategory
                       group={group}
                       setSelectedDeviceTreeGroupElements={setSelectedDeviceTreeGroupElements}
                       selectedDeviceTreeGroupElements={selectedDeviceTreeGroupElements}
                      />
                     </li>
                    )}
                   </div>
                  ))}
                 </ul>
                )}
               </div>
              ))}
             </div>
            )}
           </div>
          </Box>
         )}
        </Box>

        {/* devicetree code end */}
       </form>
      </div>
     </div>
    </div>
   )}

   <DragDropContext onDragEnd={onDragEnd}>
    <Droppable droppableId="droppable">
     {(provided) => (
      <div
       {...provided.droppableProps}
       ref={provided.innerRef}
       className="flex flex-wrap gap-2 w-[96%] mx-auto mt-5"
      >
       {isLoadingData ? (
        <div className="flex w-full">
         <div className="w-[30%] mt-8 device-loader mx-auto">
          <Skeleton className="py-1 my-1 " count={5} />
         </div>
         <div className="w-[30%] mt-8 device-loader mx-auto">
          <Skeleton className="py-1 my-1 " count={5} />
         </div>
         <div className="w-[30%] mt-8 device-loader mx-auto">
          <Skeleton className="py-1 my-1 " count={5} />
         </div>
        </div>
       ) : dashboardData?.items?.length > 0 ? (
        dashboardData?.items?.map((item: any, index: any) => (
         <Draggable
          key={item.id}
          draggableId={item.id}
          index={index}
          isDragDisabled={!dashboardData.isDraggable}
         >
          {(provided) => (
           <div {...provided.draggableProps} {...provided.dragHandleProps} ref={provided.innerRef}>
            <div className={`bg-golden rounded p-2 text-dark-gray shadow-lg relative `}>
             <div className="area">
              <ul className="circles">
               <li></li>
               <li></li>
               <li></li>
               <li></li>
               <li></li>
               <li></li>
               <li></li>
               <li></li>
               <li></li>
               <li></li>
              </ul>
             </div>
             {item.type === "Device" && (
              <div
               className={`px-2 flex flex-col justify-between ${
                item.size == "isSm"
                 ? "w-[360px]"
                 : item.size == "isMd"
                   ? "w-[500px] h-[250px]"
                   : item.size == "isLg"
                     ? "w-[600px] h-[350px]"
                     : "w-[400px] "
               }`}
              >
               <div>
                <h2 className="font-semibold text-lg text-center"> {item.name}</h2>

                <div className="flex justify-between items-center flex-wrap">
                 <h2 className="font-medium text-lg">Selected Device IDs</h2>

                 <p className="w-28 overflow-x-auto z-10 hide-scroll-icon">
                  {item?.selectedDeviceId?.join(",")}
                 </p>
                </div>
                <div className="flex justify-between items-center">
                 <h2 className="font-medium text-lg">Total Selected Devices</h2>
                 <p>{item?.selectedDeviceId && item?.selectedDeviceId?.length}</p>
                </div>
               </div>
               <div className="flex justify-between items-center w-full">
                {dashboardData.isEditable && (
                 <>
                  <div className="z-[5] w-full">
                   <Button onClick={() => handleRemoveClick(item.id)} color="lightBrown" size="sm">
                    Delete
                   </Button>
                  </div>

                  <div className="z-[5] w-full">
                   <Button onClick={() => handleEditClick(item.id)} color="lightBrown" size="sm">
                    Edit
                   </Button>
                  </div>
                 </>
                )}

                <div className="w-full z-[5]">
                 <Link to={`/selected/?deviceId=[${encodeURIComponent(item?.selectedDeviceId)}]`}>
                  <Button color="lightBrown" size="sm">
                   Go To Page
                  </Button>
                 </Link>
                </div>
               </div>
              </div>
             )}

             {item.type === "Detector" && (
              <div
               className={`px-2 flex flex-col justify-between ${
                item.size == "isSm"
                 ? "w-[360px]"
                 : item.size == "isMd"
                   ? "w-[500px] h-[250px]"
                   : item.size == "isLg"
                     ? "w-[600px] h-[350px]"
                     : "w-[400px] "
               }`}
              >
               <div>
                <h2 className="font-semibold text-lg text-center"> {item.name}</h2>

                <div className="flex justify-between">
                 <h2 className="font-medium text-lg">Total Detectors</h2>
                 <p>{detectorCounts.totalDetectors}</p>
                </div>
                <div className="flex justify-between">
                 <p className="font-medium text-lg">Malfunctioning Detectors</p>
                 <p>{detectorCounts.malfunctioningDetectors}</p>
                </div>
               </div>

               <div className="flex justify-between">
                <h2 className="font-medium text-lg">Ok Detectors</h2>
                <p>{detectorCounts.okDetectors}</p>
               </div>
               <div className="flex justify-between items-center w-full">
                {dashboardData.isEditable && (
                 <>
                  <div className="z-[5] w-full">
                   <Button onClick={() => handleRemoveClick(item.id)} color="lightBrown" size="sm">
                    Delete
                   </Button>
                  </div>

                  <div className="z-[5] w-full">
                   <Button onClick={() => handleEditClick(item.id)} color="lightBrown" size="sm">
                    Edit
                   </Button>
                  </div>
                 </>
                )}

                <div className="w-full z-[5]">
                 <Link to="/detectors">
                  <Button color="lightBrown" size="sm">
                   Go To Page
                  </Button>
                 </Link>
                </div>
               </div>
              </div>
             )}
             {item.type === "Map" && (
              <div
               className={`px-2 flex flex-col justify-between ${
                item.size == "isSm"
                 ? "w-[360px]"
                 : item.size == "isMd"
                   ? "w-[500px] h-[250px]"
                   : item.size == "isLg"
                     ? "w-[600px] h-[350px]"
                     : "w-[400px] "
               }`}
              >
               <div className="h-full">
                <h2 className="font-semibold text-lg text-center"> {item.name}</h2>

                <div className="py-2 h-full">
                 <MyMap
                  height={`${
                   item.size == "isSm"
                    ? "15vh"
                    : item.size == "isMd"
                      ? "20vh"
                      : item.size == "isLg"
                        ? "30vh"
                        : "15vh"
                  }`}
                 />
                </div>
               </div>
               <div className="flex justify-between items-center w-full">
                {dashboardData.isEditable && (
                 <>
                  <div className="z-[5] w-full">
                   <Button onClick={() => handleRemoveClick(item.id)} color="lightBrown" size="sm">
                    Delete
                   </Button>
                  </div>

                  <div className="z-[5] w-full">
                   <Button onClick={() => handleEditClick(item.id)} color="lightBrown" size="sm">
                    Edit
                   </Button>
                  </div>
                 </>
                )}

                <div className="w-full z-[5]">
                 <Link to={`/map/?deviceId=${item?.selectedDeviceId}`}>
                  <Button color="lightBrown" size="sm">
                   Go To Page
                  </Button>
                 </Link>
                </div>
               </div>
              </div>
             )}
             {item.type === "Graph" && (
              <div
               className={`px-2 flex flex-col justify-between  ${
                item.size == "isSm"
                 ? "w-[360px]"
                 : item.size == "isMd"
                   ? "w-[500px] h-[250px]"
                   : item.size == "isLg"
                     ? "w-[600px] h-[350px]"
                     : "w-[400px] "
               }`}
              >
               <div>
                <h2 className="font-semibold text-lg text-center"> {item.name}</h2>

                <div className="flex gap-2">
                 <div className="w-[40%] z-10">
                  <Input
                   className="outline-none bg-gray py-3 rounded px-3 text-black "
                   label="Begin:"
                   type="date"
                   id="begin"
                   name="begin"
                   value={date?.begin}
                   onChange={handleInputChange}
                  />
                 </div>
                 <div className="w-[40%] z-10">
                  <Input
                   className="outline-none bg-gray py-3 rounded px-3 text-black"
                   label="End:"
                   type="date"
                   id="end"
                   name="end"
                   value={date?.end}
                   onChange={handleInputChange}
                  />
                 </div>
                </div>
               </div>

               <div className="flex justify-between items-center w-full mt-10">
                {dashboardData.isEditable && (
                 <>
                  <div className="z-[5] w-full">
                   <Button onClick={() => handleRemoveClick(item.id)} color="lightBrown" size="sm">
                    Delete
                   </Button>
                  </div>

                  <div className="z-[5] w-full">
                   <Button onClick={() => handleEditClick(item.id)} color="lightBrown" size="sm">
                    Edit
                   </Button>
                  </div>
                 </>
                )}

                <div className="w-full z-[5]">
                 <Link to={`/counter-values/?deviceId=${item?.selectedDeviceId}`}>
                  <Button color="lightBrown" size="sm">
                   Go To Page
                  </Button>
                 </Link>
                </div>
               </div>

               {date.begin && date.end && (
                <div className="relative mt-10 bg-golden z-20 rounded w-full">
                 <CounterGraph
                  checkboxValues={checkboxValues}
                  selectedDetectors={selectedDetectors}
                  _selectedDeviceData={_selectedDeviceData ? _selectedDeviceData : []}
                  data={allData}
                 />
                 <div className="mt-2 whitespace-nowrap h-[280px] overflow-y-auto hide-scroll-icon rounded  bg-gray absolute top-0 right-[-10px] ">
                  <div className="bg-golden text-white mb-2 px-2">Device List</div>
                  <div className="px-1">
                   <div className="custom-checkbox">
                    <input
                     type="checkbox"
                     id="test"
                     checked={selectAll}
                     onChange={handleSelectAllChange}
                     className=""
                    />
                    <label className="font-semibold font-sm Jakarta-font" htmlFor="test">
                     all
                    </label>
                   </div>

                   {allData &&
                   allData?.length &&
                   _selectedDeviceData.length &&
                   _SingleDetectorName.length ? (
                    _SingleDetectorName.map((detector: any, index: number) => (
                     <div key={index} className="custom-checkbox">
                      <input
                       type="checkbox"
                       id={detector}
                       checked={selectedDetectors.includes(detector)}
                       onChange={() => handleDetectorCheckboxChange(detector)}
                      />
                      <label className="font-semibold font-sm Jakarta-font" htmlFor={detector}>
                       {detector}
                      </label>
                     </div>
                    ))
                   ) : (
                    <React.Fragment />
                   )}
                  </div>
                 </div>
                 <OccupancyGraph
                  checkboxValues={checkboxValues}
                  selectedDetectors={selectedDetectors}
                  _selectedDeviceData={_selectedDeviceData ? _selectedDeviceData : []}
                  data={allData}
                 />
                </div>
               )}
              </div>
             )}
            </div>
           </div>
          )}
         </Draggable>
        ))
       ) : (
        <div className="text-2xl w-full absolute inset-0 h-screen flex justify-center items-center">
         <p>Add Tiles From Dashboard Settings</p>
        </div>
       )}

       {/* Repeat the same structure for other cards */}
      </div>
     )}
    </Droppable>
   </DragDropContext>
  </div>
 )
}
